/** This page's own words. Shared vocabulary lives in `lib/labels.ts`. */
export const SETTINGS_COPY = {
  title: 'Settings',
  subtitle: 'Applies to everybody using the dashboard.',

  /* ─── [UX1 §8] WHO MAY RAISE AN ARRANGEMENT ─────────────────────────────────────── */
  arrangements: 'Raising arrangements',
  /**
   * ⚠️ IT STATES THE DEFAULT AND THE CONSEQUENCE BEFORE THE CLICK. The setting is system-wide,
   * which is not what a settings screen normally means, so the caveat sits at the field.
   */
  arrangementsHint:
    'Off by default: only the CP office raises arrangements. Turn it on and a divisional nodal may raise one for their own division.',
  /**
   * ⚠️ [UX1 §8a] THIS IS A BEHAVIOUR CHANGE AND THIS IS WHERE AN OPERATOR IS TOLD SO.
   *
   * Divisional nodals COULD raise an order before this pass — `mayAuthorArrangement` refused only
   * a UNIT — so shipping this key at `false` takes an ability away from people who have it. An
   * accepted cost recorded only in a changelog is a bug report waiting to be filed.
   */
  arrangementsWarning:
    'Turning this off takes an ability away from divisional nodals who have it today. Orders they have already started stay open and can still be published.',
  arrangementsOn: 'Divisional nodals may raise arrangements',
  arrangementsOff: 'Only super admins may raise arrangements',
  saveArrangements: 'Save',
  arrangementsSaved: 'Saved. Nodals see this on their next page load.',
} as const;
